import { IMedia } from "src/model/unityObject";
import getMediaMetadata from "./getMediaMetadata";

const hasMediaBeenGeneratedByAi = (media: IMedia) => {
  const metadata = getMediaMetadata(media);
  return metadata && typeof metadata === "object" && metadata.initialPrompt;
};

export default hasMediaBeenGeneratedByAi;
